/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
import { campaignActions } from '../actions';

const initialState = {
	pendingCampaignAdd: false,
	loading: false,
	addSuccess: false,
	jobs: [],
	matchedJobs: [],
	newJob: {}
};

function isDuplicate(currentJobs, jobId) {
	for (const currentJob of currentJobs) {
		if (currentJob.id === jobId) {
			return true;
		}
	}
	return false;
}

const campaignSlice = createSlice({
	name: 'campaign',
	initialState,
	reducers: {},
	extraReducers: {
		[campaignActions.resetState]: (state) => {
			state.loading = false;
			state.addSuccess = false;
			state.jobs = [];
			state.matchedJobs = [];
			state.newJob = {};
		},
		[campaignActions.getById.pending]: (state) => {
			state.loading = true;
		},
		[campaignActions.getById.fulfilled]: (state, action) => {
			const { job } = action.payload;

			// This is to enforce the convention that a collection must always return a list
			if (!job.candidates) {
				job.candidates = [];
			}
			state.loading = false;
			const alreadyExists = Boolean(state.jobs.filter((j) => j.id === job.id).length);
			if (!alreadyExists) {
				state.jobs.push(job);
			}
		},
		[campaignActions.getById.rejected]: (state, action) => {
			state.loading = false;
			state.error = action.payload.error;
		},
		[campaignActions.search.pending]: (state) => {
			state.loading = true;
		},
		[campaignActions.search.fulfilled]: (state, action) => {
			state.loading = false;
			state.matchedJobs = action.payload.jobs;
		},
		[campaignActions.search.rejected]: (state, action) => {
			state.loading = false;
			state.error = action.payload.error;
		},
		[campaignActions.addCampaign.pending]: (state) => {
			state.pendingCampaignAdd = true;
		},
		[campaignActions.addCampaign.fulfilled]: (state) => {
			state.pendingCampaignAdd = false;
		},
		[campaignActions.addCampaign.rejected]: (state) => {
			state.pendingCampaignAdd = false;
		},
		[campaignActions.addToCandidate.pending]: (state, action) => {
			state.loading = true;
		},
		[campaignActions.addToCandidate.rejected]: (state, action) => {
			state.loading = false;
			state.error = action.payload.error;
		},
		[campaignActions.addToCandidate.pending]: (state, _action) => {
			state.loading = true;
		},
		[campaignActions.addToCandidate.fulfilled]: (state, action) => {
			const { job } = action.payload;
			const currentJobs = state.jobs;
			if (!isDuplicate(currentJobs, job.id)) {
				let candidateCount = 0;
				if (job.candidateCount !== undefined) {
					candidateCount = job.candidateCount;
				} else if (job.candidates) {
					candidateCount = job.candidates.length;
				}
				const jobWithCandidateCount = { ...job, candidateCount };
				state.jobs.unshift(jobWithCandidateCount);
			}
			state.loading = false;
		},
		[campaignActions.addToCandidate.rejected]: (state, action) => {
			state.loading = false;
			state.error = action.payload.error;
		},
		[campaignActions.removeCandidate.pending]: (state) => {
			state.loading = true;
		},
		[campaignActions.removeCandidate.fulfilled]: (state, action) => {
			state.loading = false;
			state.jobs = state.jobs.filter((item) => item.id !== action.payload.job.id);
		},
		[campaignActions.removeCandidate.rejected]: (state, action) => {
			state.loading = false;
			state.error = action.payload.error;
		}
	}
});

export default campaignSlice;
